import React, { useState, useEffect } from 'react';
import {
	Card,
	Divider,
	Col,
	Row,
	Collapse,
	Typography,
	Skeleton,
	Badge,
	Space,
	Button
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import env from '../../../environment';
import { useSelector } from 'react-redux';
import { trace } from '../../../components/tagmanager';
import _ from 'lodash';
import OffersWidgetsData from './OffersWidgetsData';
import tagSabadell from '../../../components/tagSabadell';
import DocumentBoxesComponent from '../documentation/DocumentationNew';
import { isMobileOnly } from 'react-device-detect';

const { Text } = Typography;
const { Panel } = Collapse;

const OffersWidgets = ({ openCollapse, handleChangeCollapse, docsNumber, setDocsNumber }) => {
	const { t, i18n } = useTranslation();
	const [valuesData, setValuesData] = useState(undefined);
	const [infoAgents, setInfoAgents] = useState(undefined);
	const { operationId, stage } = useParams();
	const operations = useSelector((state) => state.auth.operations);
	const dataProfile = useSelector((state) => state.data.dataProfile);
	const userToken = useSelector((state) => state.auth.token);
	const nameOperations =
		operations !== undefined &&
		operations.find((operation) => operation.operationId === operationId);
	const rol = useSelector((state) => state.auth.roles);
	const location = useLocation();

	useEffect(() => {
		getBankOffers();
		getAgentInfo();
		trace({
			location,
			userToken,
			rol,
			stage: 'oferts',
			operationName: nameOperations && nameOperations.name
			//extra: operationsData
		});
		tagSabadell('oferta', i18n.language === 'cat' ? 'ca' : 'es');
	}, []);

	const capitalize = (str) => {
		if (!str || typeof str !== 'string') return str;
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	};

	const visibleOffers = Array.isArray(valuesData) ? valuesData.filter((o) => o?.isVisible) : [];

	const getAgentInfo = () => {
		axios
			.get(`${env.api.url}/v1/mortgages/agents/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setInfoAgents(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getBankOffers = () => {
		axios
			.get(`${env.api.url}/v1/banks/get-operation-bank-offers/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setValuesData(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const offerSkeleton = () => {
		return (
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<Card
					style={{
						width: '100%',
						maxWidth: 350,
						boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
					}}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<Skeleton.Input active size="small" />
						<Skeleton.Input active size="small" />
					</div>
					<Divider style={{ borderColor: '#E0E0E0', marginTop: 16, marginBottom: 16 }} />
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<Skeleton.Input active size="small" />
						<Skeleton.Input active size="small" />
					</div>
					<Divider style={{ borderColor: '#E0E0E0', marginTop: 16, marginBottom: 16 }} />
					<Row gutter={12} style={{ textAlign: 'left' }}>
						{[1, 2, 3].map((_, index) => (
							<Col key={index} span={24} style={{ marginBottom: 12 }}>
								<Skeleton.Input block={true} active style={{ width: '100%' }} />
							</Col>
						))}
					</Row>
					<Divider style={{ borderColor: '#E0E0E0', marginTop: 16, marginBottom: 16 }} />
					<Skeleton.Input active block={true} size="small" style={{ width: '100%' }} />
					<Divider style={{ borderColor: '#E0E0E0' }} />
					<div style={{ textAlign: 'center' }}>
						<Skeleton.Button active size="small" block={true} style={{ width: '40%' }} />
					</div>
					<Divider style={{ borderColor: '#E0E0E0', marginTop: 16, marginBottom: 16 }} />
					<div style={{ display: 'flex', gap: 16, justifyContent: 'center', width: '100&' }}>
						<Skeleton.Button active block={true} style={{ flex: 1 }} />
						<Skeleton.Button active block={true} style={{ flex: 1 }} />
					</div>
				</Card>
			</div>
		);
	};

	return (
		<>
			{stage !== 'documents' && (
				<div
					style={{
						backgroundColor: '#fff',
						display: 'flex',
						justifyContent: 'center',
						borderRadius: 4
					}}>
					<Collapse
						accordion
						style={{ width: isMobileOnly ? '100%' : 'calc(100% - 48px)', border: 'none' }}
						className={'collapse-doc'}
						defaultActiveKey={stage === 'documents' || stage === 'analysis' ? [1] : undefined}
						activeKey={openCollapse[1] ? ['1'] : undefined}
						onChange={() => handleChangeCollapse('1')}
						expandIconPosition={'end'}>
						<Panel
							header={
								<Space
									style={{ width: '100%', justifyContent: 'space-between' }}
									tabIndex={0}
									className="tab-focus">
									<Text>{t('stages.documents')}</Text>
									{docsNumber === undefined ? (
										<div style={{ width: isMobileOnly ? 100 : 150, marginTop: -10 }}>
											<Skeleton active paragraph={{ rows: 1, width: '100%' }} title={false} />
										</div>
									) : (
										docsNumber > 0 && (
											<Text style={{ fontSize: 12, fontWeight: 600, color: '#212121' }}>
												{isMobileOnly ? (
													<div>
														{docsNumber}{' '}
														{docsNumber === 1 ? t('doc.pendingDocBrev') : t('doc.pendingDocsBrev')}{' '}
													</div>
												) : (
													<>
														{stage === 'documents' ? (
															<div>
																{docsNumber}{' '}
																{docsNumber === 1
																	? t('doc.pendingNeededDoc')
																	: t('doc.pendingNeededDocs')}{' '}
															</div>
														) : (
															<div>
																{docsNumber}{' '}
																{docsNumber === 1
																	? t('doc.pendingOptionalDoc')
																	: t('doc.pendingOptionalDocs')}
															</div>
														)}
													</>
												)}
											</Text>
										)
									)}
								</Space>
							}
							key="1">
							<div style={{ marginTop: -20 }}>
								<DocumentBoxesComponent
									userMortgageId={operationId}
									stage={stage}
									setDocsNumber={setDocsNumber}
								/>
							</div>
						</Panel>
					</Collapse>
				</div>
			)}
			<div
				style={{ marginTop: isMobileOnly ? 8 : 16 }}
				className={`collapse-offer ${!openCollapse[2] ? 'collapse-offer-close' : ''} ${
					isMobileOnly ? 'collapse-offer-mobile' : ''
				}`}>
				<Collapse
					accordion
					className={visibleOffers?.length > 0 ? 'blue-arrow' : ''}
					style={{ width: '100%', border: 'none' }}
					defaultActiveKey={
						stage === 'appraisal' ||
						stage === 'formalization' ||
						stage === 'documents' ||
						stage === 'analysis'
							? undefined
							: ['1']
					}
					activeKey={openCollapse[2] ? ['1'] : undefined}
					onChange={() => handleChangeCollapse('2')}
					expandIconPosition={'end'}>
					<Panel
						header={
							<Space
								style={{ width: '100%', justifyContent: 'space-between' }}
								tabIndex={0}
								className="tab-focus">
								<Text>{t('m_offers.title')}</Text>
								{valuesData === undefined ? (
									<div style={{ width: isMobileOnly ? 100 : 150, marginTop: -10 }}>
										<Skeleton active paragraph={{ rows: 1, width: '100%' }} title={false} />
									</div>
								) : (
									<>
										{visibleOffers.length > 0 && (
											<Text style={{ fontSize: 14, fontWeight: 600, color: '#006DFF' }}>
												{visibleOffers.length + ' '}
												{visibleOffers.length > 1 ? t('doc.offers') : t('doc.offer')}
											</Text>
										)}
									</>
								)}
							</Space>
						}
						key="1">
						<div
							style={{
								paddingBottom: 12,
								marginLeft: !isMobileOnly && 24,
								marginRight: !isMobileOnly && 24
							}}>
							<Row style={{ display: 'flex', flexDirection: 'column' }}>
								<div
									style={{ color: '#006DFF', fontWeight: 700, fontSize: isMobileOnly ? 20 : 32 }}>
									{t('offers.haveAnOfferTitle', { name: capitalize(dataProfile?.name) })}
								</div>
								{visibleOffers?.some((bankOffer) => bankOffer.isFavorite) ? (
									<div
										style={{ color: '#212121', fontWeight: 400, fontSize: isMobileOnly ? 14 : 18 }}>
										{t('offers.choosenOffer')}
									</div>
								) : (
									<div
										style={{ color: '#212121', fontWeight: 400, fontSize: isMobileOnly ? 14 : 18 }}>
										{t('offers.haveAnOfferDescription')}
									</div>
								)}
							</Row>
							<Row
								align={'bottom'}
								justify={'end'}
								style={{
									marginTop: isMobileOnly ? 8 : 16,
									display: 'flex',
									justifyContent: visibleOffers?.length > 2 ? undefined : 'flex-end',
									flexWrap: 'wrap',
									gap: isMobileOnly ? 16 : 24
								}}>
								{Array.isArray(valuesData) ? (
									<>
										{valuesData.length > 0 && visibleOffers.length === 0 ? (
											<Card
												className="card-offer"
												style={{
													width: '100%',
													maxWidth: 350,
													textAlign: 'center',
													boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
													borderRadius: 4
												}}>
												<div style={{ maxWidth: 350 }}>
													<Text style={{ fontSize: 24, fontWeight: 700 }}>{t('offer.ready')}</Text>
													<Divider style={{ margin: '16px 0px' }} />
													<Text>
														{t('offer.contact', { name: capitalize(dataProfile?.name) })}
														<br />
														{infoAgents?.analyst?.name && (
															<strong>
																{t('offer.call', { name: capitalize(infoAgents?.analyst?.name) })}
															</strong>
														)}
													</Text>
												</div>
											</Card>
										) : (
											<>
												{valuesData.some((o) => !o.isVisible) && (
													<Col
														xs={24}
														sm={20}
														md={16}
														lg={12}
														xl={11}
														xxl={11}
														style={{
															display: 'flex',
															justifyContent: 'center',
															alignItems: 'center',
															width: '100%',
															maxWidth: 450,
															alignSelf: 'flex-start'
														}}>
														<Card
															className="card-offer"
															style={{
																width: '100%',
																boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
																borderRadius: 4
															}}>
															<div style={{ maxWidth: 350, margin: '0 auto', textAlign: 'center' }}>
																<Text style={{ fontSize: 24, fontWeight: 700 }}>
																	{t('offer.otherOffers')}
																</Text>
																<Divider style={{ margin: '16px 0px' }} />
																<Text>
																	{t('offer.contact', { name: capitalize(dataProfile?.name) })}
																	<br />
																	{infoAgents?.analyst?.name && (
																		<strong>
																			{t('offer.call', {
																				name: capitalize(infoAgents?.analyst?.name)
																			})}
																		</strong>
																	)}
																</Text>
															</div>
														</Card>
													</Col>
												)}

												{visibleOffers.map((bankOffer, index) => {
													let years = bankOffer.term / 12;
													return (
														<Col
															xs={24}
															sm={20}
															md={16}
															lg={12}
															xl={11}
															xxl={11}
															key={bankOffer?.id}
															style={{
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																width: '100%',
																maxWidth: 450
															}}>
															<OffersWidgetsData
																getBankOffers={getBankOffers}
																valuesData={visibleOffers}
																numberOffers={visibleOffers.length}
																bankOffer={bankOffer}
																years={years}
															/>
														</Col>
													);
												})}
											</>
										)}
									</>
								) : (
									<>{offerSkeleton()}</>
								)}
							</Row>
						</div>
					</Panel>
				</Collapse>
			</div>
		</>
	);
};

export default OffersWidgets;
